// Query string for GET /api/ads/showcase-candidates.
// `static` is the builder's label for Ad.kind === 'image'.

export type ShowcaseCandidate = {
  id: string;
  kind: 'image' | 'video';
  platformFormat: string | null;
  productId: string | null;
  qc: {
    state: 'passed' | 'failed' | 'uninspected';
    failedCategories: string[];
  };
};

export type ShowcaseCandidateResponse = {
  ads: ShowcaseCandidate[];
  counts: {
    eligible: number;
    passed: number;
    failed: number;
    uninspected: number;
    byCategory: Record<string, number>;
    matched: number;
    returned: number;
    cap: number;
    overflow: boolean;
  };
  facets: {
    kinds: { value: string; count: number }[];
    formats: { value: string; count: number }[];
  };
};

export type ShowcaseCandidateQuery = {
  brandId: string;
  campaignId: string;
  kind?: string;
  platformFormat?: string;
  qc?: string;
};

function setIfChosen(q: URLSearchParams, key: string, value: string | undefined) {
  if (!value || value === 'all') return;
  q.set(key, value);
}

export function buildShowcaseCandidatesPath(opts: ShowcaseCandidateQuery): string {
  const q = new URLSearchParams();
  q.set('brandId', opts.brandId);
  q.set('campaignId', opts.campaignId);
  const kind = opts.kind === 'static' ? 'image' : opts.kind;
  setIfChosen(q, 'kind', kind);
  setIfChosen(q, 'platformFormat', opts.platformFormat);
  setIfChosen(q, 'qc', opts.qc);
  return `/api/ads/showcase-candidates?${q.toString()}`;
}
